import { useQuery } from '@apollo/client';
import { HASURA_DISCOVER_PROGRAM_TYPES } from '@rivallapp/shared/discover/filters';
import type { FC } from 'react';

import { withPropsFromUrl } from './utils';
import { FilterSelect, Error as ErrorComponent } from '../../components';
import { startCase } from '../../shared/string-manipulations';
import { filtersWhereClause, type SharedFilterProps, type WithPropsFromUrl } from './types';
import type { ProgramTypeEnum } from '../../shared/program-type-enum';

const ProgramTypeFilter: FC<WithPropsFromUrl & SharedFilterProps> = props => {
  const {
    programTypes = [],
    disabled = false,
    onSelect,
    isMulti = false,
    className = '',
    updateSearchUrls,
    cityName = 'Baltimore',
    skip = false,
  } = props;

  const {
    data: programTypesData,
    loading: programTypesLoading,
    error: programTypesError,
  } = useQuery(HASURA_DISCOVER_PROGRAM_TYPES, {
    skip: skip || !cityName,
    fetchPolicy: 'cache-and-network',
    variables: {
      where: filtersWhereClause(props, { programTypes: false }),
    },
  });

  const { leagues = [] } = programTypesData ?? {};

  const programTypesOptions = leagues.map(({ program_type }) => ({
    label: startCase(program_type.replace('_', ' - ')),
    value: program_type,
  }));

  const onChange =
    typeof onSelect === 'function'
      ? onSelect
      : (v = []) => {
          updateSearchUrls({ programTypes: v.map(({ value }) => value) });
        };

  if (programTypesError) return <ErrorComponent error={programTypesError} />;

  return (
    <FilterSelect
      short
      shadow
      labelSingular="Program Type"
      labelPlural="Program Types"
      options={programTypesOptions}
      value={
        programTypesOptions.filter(({ value }) =>
          programTypes.includes(value as ProgramTypeEnum)
        ) || null
      }
      onChange={onChange}
      disabled={disabled || programTypesLoading}
      multi={isMulti}
      className={className}
    />
  );
};

export default withPropsFromUrl()(ProgramTypeFilter);
